import { initAddToCal } from '../add-to-cal-button/addToCal';

document.addEventListener('DOMContentLoaded', function () {
  initAddToCal();
});
